export const SEARCH_DEPLOYMENT_ID =
  'f998f418-144e-4b01-bdaf-4cd3fee16125' as const

export const TRENDING_SEARCHES_IDS = [
  {
    predictionId: 'sm_el_bb1f49b608cb4e8889af5a67c8e11524',
    name: 'Giorgio Armani',
    id: 'giorgio-armani',
  },
  {
    predictionId: 'sm_el_10518bba64b34d329f2701063b3235c3',
    name: 'Emporio Armani',
    id: 'emporio-armani',
  },
  {
    predictionId: 'sm_el_5835d21df6b44c839f37950e2e57fbb4',
    name: 'EA7',
    id: 'ea7',
  },
  {
    predictionId: 'sm_el_dddc4cfb6bea487496a150e43f9ffc8c',
    name: 'Armani Exchange',
    id: 'armani-exchange',
  },
  {
    predictionId: 'sm_el_7719e5203e91463d9fe6d6c82a40b613',
    name: 'Armani Casa',
    id: 'armani-casa',
  },
] as const

export const TRENDING_SEARCHES_NO_RESULTS_IDS = [
  {
    predictionId: 'sm_el_db97d3c3ab4a4ee196c0cf52265f6d10',
    name: 'Giorgio Armani',
    id: 'giorgio-armani',
  },
  {
    predictionId: 'sm_el_fe593157445a4c61b1705334db14c71b',
    name: 'Emporio Armani',
    id: 'emporio-armani',
  },
  {
    predictionId: 'sm_el_d53c85eb15cf48f5b64e0d7014209e64',
    name: 'EA7',
    id: 'ea7',
  },
  {
    predictionId: 'sm_el_2e735a8042d94cc2ac391e267073c71c',
    name: 'Armani Exchange',
    id: 'armani-exchange',
  },
  {
    predictionId: 'sm_el_cccdeaa1c3c04811a2fb7923cc00db22',
    name: 'Armani Casa',
    id: 'armani-casa',
  },
] as const

export const PDP_YOU_MAY_ALSO_LIKE_ID = 'sm_el_207bb7a99c814e06a331bf90eba6b187'

/** Track-order "Scelti per te": single-brand orders use the brand ID, any other order uses `mixed`. */
export const TRACK_ORDER_SELECTED_FOR_YOU_IDS = {
  armaniExchange: 'sm_el_6cde9ad82d794468b6ed7479a053329f',
  ea7: 'sm_el_fd4dd18e532e480f9d793a4fdd498e68',
  emporioArmani: 'sm_el_c00c168847114a27922f6f43ecfe390f',
  giorgioArmani: 'sm_el_58992b0940ce4631bd549067dd3f7595',
  mixed: 'sm_el_23a4e32c24a14cb1912269a8102d07dd',
} as const

export const PDP_YOU_MAY_ALSO_LIKE_ID_REDESIGN =
  'sm_el_ea1ada217f504edfac0cc5b6885d14e8'

export const PLP_FIRST_ROW_COMPONENT_ID =
  'sm_el_eabec7af4e144a8ba0d3c2148766b026'

export const PLP_SELECTED_FOR_YOU_ID = 'sm_el_d9cdc77054494026818cd2284f1f7682'

export const PDP_SIMILAR_PRODUCTS_ID = 'sm_el_a94f963077e24352a9b93c78e7738ae2'

export const MY_ACCOUNT_SELECTED_FOR_YOU_ID =
  'sm_el_a7b81c4aa53a42c891a8d4a519b96844'

export const CART_FEEDBACK_YOU_MAY_ALSO_LIKE_IDS =
  'sm_el_c0c27a6b107e442cbef2ba13c9c2d76d'

export const MINI_CART_EMPTY_SELECTED_FOR_YOU_IDS = {
  crossBrand: 'sm_el_0d1bb662b49a41dc87e97109ad95d727',
  giorgioArmani: 'sm_el_d8564d4420db441d96aa9e9b7d27563d',
  emporioArmani: 'sm_el_ad7faeb652764600b0c32b07927dd6e8',
  ea7: 'sm_el_178b5742ce314ec19e128d6c8f9a0cd2',
  armaniExchange: 'sm_el_5b3bbaba1e6d479eb5396c67996b1fd6',
}

export const CART_YOU_MAY_ALSO_LIKE_IDS = {
  armaniCasa: 'sm_el_ce1229522ed345adb15ee5d672afab97',
  armaniExchange: 'sm_el_7169bd5b05504f188288a6f0bea50b3f',
  ea7: 'sm_el_f7397d89051447dba54bfc9de13d86d7',
  emporioArmani: 'sm_el_5163e98311134c08bb01bac7423c2475',
  giorgioArmani: 'sm_el_bca581c4b2a549d3a2f240ff6b9aa56a',
}

export const LAST_VIEWED_YOU_MAY_ALSO_LIKE_IDS = {
  crossBrand: 'sm_el_9258da6ffdd14feb9bdf53b3480bd09c',
  emporioArmani: 'sm_el_e778c47559d6451d8a420a58b3f14f42',
  armaniExchange: 'sm_el_6c9c22e61a0d4ba69f89027043b3a0fd',
  giorgioArmani: 'sm_el_5f7e8562e31e4f3bafbc392cdf7c9609',
  ea7: 'sm_el_23adad9c1c454fed8d51faa7ec88d123',
  armaniCasa: 'sm_el_74f941989c0a4c28b8907814bc91edc1',
}

export const CHECKOUT_THANK_YOU_YOU_MAY_ALSO_LIKE_ID =
  'sm_el_b0d9287c29c144ad835ac966d273f260'

export const WISHLIST_YOU_MAY_ALSO_LIKE_IDS = {
  armaniCasa: 'sm_el_b733fa92c471417182229a7d28b96a24',
  armaniExchange: 'sm_el_431c795cf2694dcfbc63bf34a3c1804e',
  ea7: 'sm_el_7fcc86f9c6844752aa843d0a9e17e8d1',
  emporioArmani: 'sm_el_f543410d93d743638ab6f3e3da861357',
  giorgioArmani: 'sm_el_1c10f8a395cd429f84b7ea0174711865',
  wishlistFull: 'sm_el_e9f7bf9be1274e6cb0d6b5889cb67b9b',
}
